import React from "react";
import { chakra, useMultiStyleConfig } from "@chakra-ui/react";
export function SelectOptionLabel(props) {
    const styles = useMultiStyleConfig("SelectOption");
    return React.createElement(chakra.span, { __css: styles["label"], ...props });
}
